export enum AccessActivePeriodStartingOptions {
  NO_LIMIT = 'NO_LIMIT',
  BOOKING_ACTIVE_DATE = 'BOOKING_ACTIVE_DATE',
  FIRST_USE = 'FIRST_USE',
  BOOKING_CREATED_DATE = 'BOOKING_CREATED_DATE',
}
